import React from "react";

function GuardIntro() {
    return (
        <div>
            <h2>Introduction to Security Guarding</h2>
            <p>
                Security guards are essential to maintaining safety, protecting property, and ensuring order in a wide range of environments — from retail stores and office buildings to construction sites and public spaces.
            </p>

            <h3>Role of a Security Guard</h3>
            <ul>
                <li>Protect people, property, and assets</li>
                <li>Prevent unauthorized access and criminal activity</li>
                <li>Monitor CCTV and alarm systems</li>
                <li>Respond to incidents and emergencies</li>
                <li>Provide customer service and support</li>
            </ul>

            <h3>Legal Framework</h3>
            <ul>
                <li><strong>Private Security Industry Act 2001</strong> – Establishes licensing and regulation</li>
                <li><strong>Health and Safety at Work Act 1974</strong> – Ensures safety for all on site</li>
                <li><strong>Human Rights Act 1998</strong> – Protects dignity and equality</li>
                <li><strong>Data Protection Act 2018</strong> – Governs handling of personal data</li>
            </ul>

            <h3>Key Skills and Attributes</h3>
            <ul>
                <li>Vigilance and attention to detail</li>
                <li>Strong communication and observation skills</li>
                <li>Calm and confident under pressure</li>
                <li>Professional appearance and conduct</li>
                <li>Understanding of equality and diversity</li>
            </ul>

            <h3>Licensing Requirements</h3>
            <ul>
                <li>Must be 18 years or older</li>
                <li>Complete an approved SIA Security Guard training course</li>
                <li>Hold a valid Emergency First Aid at Work certificate</li>
                <li>Pass identity and criminal background checks</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/security-guard-licence" target="_blank" rel="noreferrer">UK Gov – Security Guard Licence</a></li>
                <li><a href="https://www.sia.homeoffice.gov.uk/" target="_blank" rel="noreferrer">SIA – Security Industry Authority</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Training Standards</a></li>
            </ul>
        </div>
    );
}

export default GuardIntro;
